export default {
  TO: {
    HELP: 'The client and any other participants on this order will also receive this message',
    SELECT: 'Add recipient(s) to send a comment'
  },
  TEXT: {
    PLACEHOLDER: 'Enter a comment'
  }
}
